import(/* webpackMode: "eager" */ "/codebuild/output/src219312042/src/apps/junonkuji/src/app/error.tsx");
